import React, { useState } from 'react';
import SubscribeForm from 'components/Form/SubscribeForm';
import { Container } from './styles';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';
import useStatsigHelper from 'utils/useStatsigHelper';

const HeroSubscribeForm = ({ dataTestId, style, id, ...props }) => {
  const [isMarketingModalOpen, toggleIsMarketingModalOpen] = useState(false);
  const onSuccessModalMarketoForm = useStatsigHelper(
    props?.inlineMarketingForm?.onFormSubmissionInlineMarketingForm,
  );

  const onSuccess = () => {
    if (onSuccessModalMarketoForm) {
      toggleIsMarketingModalOpen(true);
    }
  };

  return (
    <Container
      style={style}
      id={id}
      theme={props?.theme}
      className="hero-subscribe-form-container"
      data-testid={dataTestId}
    >
      <SubscribeForm
        onSuccess={onSuccess}
        className="hero-subscribe-form"
        data-position="Hero"
        {...props}
      />
      {onSuccessModalMarketoForm && (
        <ModalMarketingForm
          dataPosition={props?.dataPosition}
          isModalOpen={isMarketingModalOpen}
          shouldRedirect={props?.shouldRedirect}
          onModalCancel={() => toggleIsMarketingModalOpen(false)}
          inlineMarketingForm={onSuccessModalMarketoForm}
          onFormSuccess={() => {
            toggleIsMarketingModalOpen(false);
          }}
        />
      )}
    </Container>
  );
};

HeroSubscribeForm.defaultProps = {
  buttonColor: 'blue',
  notificationMessage:
    'Thanks for subscribing! Please check your mail to confirm your subscription',
  revealProps: {
    styles: 'hero-subscribe-form--legal-info',
  },
};

export default HeroSubscribeForm;
